// extracted by mini-css-extract-plugin
module.exports = {"logo":"index-module--logo--1fq4T","menu":"index-module--menu--2CAGc"};